<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="25"
      cy="25"
      r="18.75"
      stroke="url(#paint0_linear_3404_9956)"
      stroke-width="2.5"
    />
    <path
      d="M24.9997 39.0404C25.8511 39.0404 26.5413 38.3501 26.5413 37.4987C26.5413 36.6473 25.8511 35.957 24.9997 35.957C24.1482 35.957 23.458 36.6473 23.458 37.4987C23.458 38.3501 24.1482 39.0404 24.9997 39.0404Z"
      fill="url(#paint1_linear_3404_9956)"
      stroke="url(#paint2_linear_3404_9956)"
    />
    <path
      d="M25 33.332V31.5471C25 30.0591 25.7436 28.6696 26.9817 27.8442L28.2285 27.013C30.1162 25.7546 31.25 23.636 31.25 21.3673V20.832C31.25 17.3803 28.4518 14.582 25 14.582V14.582C21.5482 14.582 18.75 17.3803 18.75 20.832V20.832"
      stroke="url(#paint3_linear_3404_9956)"
      stroke-width="2.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3404_9956"
        x1="22.358"
        y1="-4.31818"
        x2="54.7644"
        y2="3.78343"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3404_9956"
        x1="24.8529"
        y1="35.8699"
        x2="26.6532"
        y2="36.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3404_9956"
        x1="24.8529"
        y1="35.8699"
        x2="26.6532"
        y2="36.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3404_9956"
        x1="24.1193"
        y1="9.29794"
        x2="35.2864"
        y2="11.1591"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
